module.exports = __webpack_public_path__ + "static/media/SWIFT_2019_pic.d01f50fd.jpeg";